<header class="header">
    <div class="header-container">
        <a routerLink="/" class="logo">
            <img [src]="logoSrc()" alt="Alta Sistemas" class="logo-image">
        </a>

        <nav class="nav" [class.nav-open]="mobileMenuOpen">
            <a href="#servicos" (click)="scrollToSection($event, 'servicos')">Serviços</a>
            <a href="#processo" (click)="scrollToSection($event, 'processo')">Processo</a>
            <a href="#duvidas" (click)="scrollToSection($event, 'duvidas')">Dúvidas</a>
            <a routerLink="/contato" class="contact-link" (click)="closeMobileMenu()">Fale Conosco</a>

            <button class="theme-toggle desktop-only" (click)="toggleTheme()"
                [attr.aria-label]="currentTheme === 'dark' ? 'Mudar para tema claro' : 'Mudar para tema escuro'">
                <span class="material-symbols-outlined">
                    {{ currentTheme === 'dark' ? 'light_mode' : 'dark_mode' }}
                </span>
            </button>
        </nav>

        <div class="header-actions">
            <!-- Mobile Toggle (Visible only on mobile, left of hamburger) -->
            <button class="theme-toggle mobile-only" (click)="toggleTheme()"
                [attr.aria-label]="currentTheme === 'dark' ? 'Mudar para tema claro' : 'Mudar para tema escuro'">
                <span class="material-symbols-outlined">
                    {{ currentTheme === 'dark' ? 'light_mode' : 'dark_mode' }}
                </span>
            </button>

            <button class="mobile-menu-toggle" (click)="toggleMobileMenu()"
                [attr.aria-label]="mobileMenuOpen ? 'Fechar menu' : 'Abrir menu'" [attr.aria-expanded]="mobileMenuOpen">
                <span class="material-symbols-outlined">
                    {{ mobileMenuOpen ? 'close' : 'menu' }}
                </span>
            </button>
        </div>
    </div>
</header>